import Vue from "vue"
import Vuex from "vuex"
import VuexPersistence from "vuex-persist"
import api from "@/services/api"

Vue.use(Vuex)

const vuexSession = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: (state) => ({
    // text: state.text,
    // colours: state.colours,
    // extras: state.extras,
    // examples: state.examples,

    personal: state.personal,
    style: state.style,
    inscription_text: state.inscription_text,
    selectedExtras: state.selectedExtras,
  }),
})

var types = [
  { value: "new", label: "Creating a new memorial" },
  { value: "rennovation", label: "Rennovating an existing memorial" },
  { value: "inscription", label: "Adding an inscription to an existing memorial" },
]
var starter_name = "Mr John Doe"
var starter_inscription = `
<p style='text-align: center;'><span style='font-family:Zaph Chancery Demi;'><span style='font-size:1.6rem;'>In Loving Memory of</span></span></p><p style='text-align: center;'><span style='font-family:Goudy Old Style Bold;'><span style='font-size:1.6rem;'>${starter_name}</span></span></p><p style='text-align: center;'><span style='font-family:Goudy Old Style Bold;'><span style='font-size:1.6rem;'>Affectionally known as 'uncle'</span></span></p><p style='text-align: center;'><span style='font-family:Goudy Old Style Bold;'><span style='font-size:1.6rem;'>1st May 1945 to 22nd June 2019</span></span></p><p style='text-align: center;'><span style='font-family:Goudy Old Style Bold;'><span style='font-size:1.6rem;'>A dearly loved Husband, Uncle and Friend</span></span></p><p style='text-align: center;'><span style='font-family:Zaph Chancery Demi;'><span style='font-size:1.6rem;'>Remembered with a smile</span></span></p>
`

export default new Vuex.Store({
  plugins: [vuexSession.plugin],
  getters: {},
  mutations: {
    setExtras(state, extras) {
      state.extras = extras
    },
    setExamples(state, examples) {
      state.examples = examples
    },
    setSizes(state, sizes) {
      state.shapes.forEach((shape) => {
        if (sizes[shape.value + "_sizes"]) shape.sizes = sizes[shape.value + "_sizes"].map((s) => s.value)
      })
    },
    setColours(state, colours) {
      state.colours = colours
    },
    setText(state, text) {
      state.text = text
    },
    setPersonal(state, personal) {
      state.personal = personal
    },
    setStyle(state, options) {
      state.style = options
    },
    setInscriptionText(state, options) {
      state.inscription_text = options
    },
    setInscription(state, options) {
      state.inscription = options
    },
    setRennovation(state, options) {
      state.rennovation = options
    },
    setSelectedExtras(state, options) {
      state.selectedExtras = options
      state.selectedExtras.sort(function (a, b) {
        var aExtra = a[2]
        var bExtra = b[2]
        var aOption = a[3]
        var bOption = b[3]

        if (aExtra == bExtra) {
          return aOption < bOption ? -1 : aOption > bOption ? 1 : 0
        } else {
          return aExtra < bExtra ? -1 : 1
        }
      })
    },
  },
  actions: {
    getText({ commit, state }) {
      return new Promise((resolve) => {
        if (!state.text)
          api.getPageByItemID("TEXT").then((text) => {
            commit("setText", text)
            resolve()
          })
        else resolve()
      })
    },
    getColours({ commit, state }) {
      return new Promise((resolve) => {
        if (!state.colours)
          api.getPageByItemID("COLOURS").then((page) => {
            commit("setColours", page.Colours)
            resolve()
          })
        else resolve()
      })
    },
    getExamples({ commit, state }) {
      return new Promise((resolve) => {
        if (!state.examples)
          api.getPageByItemID("EXAMPLES").then((page) => {
            commit("setExamples", page.Examples)
            resolve()
          })
        else resolve()
      })
    },
    getSizes({ commit, state }) {
      return new Promise((resolve) => {
        if (!state.examples)
          api.getPageByItemID("SIZES").then((sizes) => {
            commit("setSizes", sizes)
            resolve()
          })
        else resolve()
      })
    },
    getExtras({ commit, state }) {
      return new Promise((resolve) => {
        if (!state.extras)
          api.getPages("products,description", "page.categories").then((extras) => {
            commit("setExtras", extras)
            resolve()
          })
        else resolve()
      })
    },
  },

  state: {
    site_id: "ctbutterfield",
    personal: { type: types[0] },
    style: {
      type: "",
      shape: {},
      colour: {},
      size: "_",
      product: "",
      photo: "",
    },

    starter_name,
    starter_inscription,
    inscription_text: starter_inscription,

    selectedExtras: [],

    rennovation: {},
    inscription: {},

    shapes: [
      {
        name: "Heart",
        value: "Heart",
        image: "heart.jpg",
        sizes: [],
      },
      {
        name: "Ogee",
        value: "Ogee",
        image: "ogee.jpg",
        sizes: [],
      },
      {
        name: "Camber",
        value: "Camber",
        image: "camber.jpg",
        sizes: [],
      },
      {
        name: "Half Ogee",
        value: "HalfOgee",
        image: "half-ogee.jpg",
        sizes: [],
      },
      {
        name: "Cremation Tablet",
        value: "CrematoriumTablet",
        image: "tablet.jpg",
        sizes: [],
      },
    ],

    text: null,
    colours: null,
    extras: null,
    examples: null,
    types,
  },
})
